import React from 'react';
import { guarantee } from '../data/content';
export function GuaranteeSection() {
  return <section aria-labelledby="guarantee-title" className="bg-mist py-12 md:py-16" data-id="element-85" data-mp="4uqe0xagm4tu">
      <div className="mx-auto flex max-w-[860px] flex-col items-center gap-6 px-5 text-center md:flex-row md:gap-10 md:px-8 md:text-left" data-id="element-86" data-mp="9umhmvf8vu8v">
        <div className="flex h-36 w-36 shrink-0 items-center justify-center rounded-full border-[3px] border-sun p-1.5" aria-hidden="true" data-id="element-87" data-mp="eu8v95yzjci7">
          {/* text-center: the Italian seal text ("10 GIORNI") wraps to 2 lines, kept centered on desktop too */}
          <div className="flex h-full w-full flex-col items-center justify-center rounded-full bg-brand text-center" data-id="element-88" data-mp="skue4uofvmg3">
            <span className="font-display text-[1.9rem] font-black leading-none text-sun" data-id="element-89" data-mp="xkgs56c3d6py">{guarantee.sealTop}</span>
            <span className="mt-1.5 font-display text-[10px] font-bold tracking-[0.12em] text-white" data-id="element-90" data-mp="12k34zeo0cky8">{guarantee.sealBottom}</span>
          </div>
        </div>
        <div data-id="element-91" data-mp="25rx8om5t6ryg">
          <h3 id="guarantee-title" className="font-display text-[1.4rem] font-black uppercase leading-tight tracking-tight text-brand md:text-[1.8rem]" data-id="element-92" data-mp="25rnfkppgw4oj">
            {guarantee.title}
          </h3>
          <p className="mt-3 text-[16px] leading-relaxed text-ink/75 md:text-[17px]" data-id="element-93" data-mp="1vthkos22vyt6">{guarantee.text}</p>
        </div>
      </div>
    </section>;
}